import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { AumDialog, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER } from './dialog';
import { AumDialogContainer } from './dialog-container';
import {
    AumColoredHeadline,
    AumDialogActions,
    AumDialogContent,
    AumDialogTitle,
    MatDialogClose,
} from './dialog-content-directives';

@NgModule({
    imports: [CommonModule, OverlayModule, PortalModule, MatCommonModule],
    exports: [
        AumDialogContainer,
        MatDialogClose,
        AumDialogTitle,
        AumDialogContent,
        AumColoredHeadline,
        AumDialogActions,
        MatCommonModule,
    ],
    declarations: [
        AumDialogContainer,
        MatDialogClose,
        AumDialogTitle,
        AumDialogActions,
        AumDialogContent,
        AumColoredHeadline,
    ],
    providers: [AumDialog, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER]
})
export class AumDialogModule {}
